var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionPagemode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/outlined/chevron_double_rifht"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93934 8.93934C9.52513 8.35355 10.4749 8.35355 11.0607 8.93934L25.0607 22.9393C25.342 23.2206 25.5 23.6022 25.5 24C25.5 24.3978 25.342 24.7794 25.0607 25.0607L11.0607 39.0607C10.4749 39.6464 9.52513 39.6464 8.93934 39.0607C8.35355 38.4749 8.35355 37.5251 8.93934 36.9393L21.8787 24L8.93934 11.0607C8.35355 10.4749 8.35355 9.52513 8.93934 8.93934ZM24.9393 8.93934C25.5251 8.35355 26.4749 8.35355 27.0607 8.93934L41.0607 22.9393C41.6464 23.5251 41.6464 24.4749 41.0607 25.0607L27.0607 39.0607C26.4749 39.6464 25.5251 39.6464 24.9393 39.0607C24.3536 38.4749 24.3536 37.5251 24.9393 36.9393L37.8787 24L24.9393 11.0607C24.3536 10.4749 24.3536 9.52513 24.9393 8.93934Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionPagemode);
export default __webpack_public_path__ + "static/media/direction_pagemode.b33b39894ea42e0a162a15476dabe09e.svg";
export { ForwardRef as ReactComponent };